import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { hasProductVersionInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { calculatedPriceSelector, planAdditionalCostSelector } from '../../../selectors/PricingSelectors';
import { HighlightedPriceDisplay } from '../../common/pricing/HighlightedPriceDisplay';
import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';

const HighlightedMerchPriceDisplay = (_ref) => {
  let {
    skuId,
    quantityPackSkuId,
    quantityPackQuantity,
    queryParamTerm,
    style = {}
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["skuId", "quantityPackSkuId", "quantityPackQuantity", "queryParamTerm", "style"]);

  const productConfigurations = [createProductConfig({
    skuId
  })];
  if (quantityPackSkuId && quantityPackQuantity && quantityPackQuantity > 0) productConfigurations.push(createProductConfig({
    skuId: quantityPackSkuId,
    quantity: quantityPackQuantity
  }));
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const showingOnlyAdditionalCost = useSelector(state => {
    return !isUngatedForSeats && hasProductVersionInProductInventorySelector(state, {
      skuId
    });
  });
  const pricingInfo = useSelector(state => showingOnlyAdditionalCost ? planAdditionalCostSelector(state, {
    productConfigurations,
    queryParamTerm
  }) : calculatedPriceSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
    pricingInfo: pricingInfo,
    skuId: skuId,
    wrapperStyle: style,
    showingOnlyAdditionalCost: showingOnlyAdditionalCost
  }, rest));
};

export default HighlightedMerchPriceDisplay;